import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { usePolicy } from '../../hooks/usePolicy'

function PolicyLink ({ to, policy, children, ...props }) {
  const enabled = usePolicy(policy)

  if (!enabled) return null

  return (
    <Link {...props} to={to}>
      {children}
    </Link>
  )
}

PolicyLink.propTypes = {
  to: PropTypes.string,
  policy: PropTypes.string,
  children: PropTypes.node
}

export default PolicyLink
